module.exports = __webpack_public_path__ + "static/media/userProfile.fde4aa97.svg";